@if (videoSession) {
  <div
  [ngClass]="{
    'video-list': true,
    'video-list--single': activeLayout === availableLayouts.single,
    'video-list--double': activeLayout === availableLayouts.double,
    'video-list--triple': activeLayout === availableLayouts.triple
  }"
    data-private
    >
    <app-publisher [videoSession]="videoSession"></app-publisher>
    @for (stream of streams; track stream) {
      <app-subscriber
        [stream]="stream"
        [videoSession]="videoSession"
      ></app-subscriber>
    }
  </div>
}
